"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeaturedTitleProperty = exports.featuredTitlePropertyDefinition = void 0;
exports.featuredTitlePropertyDefinition = {
    view: {
        label: 'Featuring title',
        hint: 'This title will be shown whenever the content is presented on a card. Make it engaging.',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 55,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'featured-title',
};
const isFeaturedTitleProperty = (prop) => {
    return prop.name === exports.featuredTitlePropertyDefinition.name;
};
exports.isFeaturedTitleProperty = isFeaturedTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZWQtdGl0bGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9mZWF0dXJlZC10aXRsZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLCtCQUErQixHQUFHO0lBQzdDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxpQkFBaUI7UUFDeEIsSUFBSSxFQUFFLHlGQUF5RjtLQUNoRztJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEVBQUU7U0FDYjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxnQkFBZ0I7Q0FDUyxDQUFBO0FBSTFCLE1BQU0sdUJBQXVCLEdBQUcsQ0FBQyxJQUFrQixFQUFpQyxFQUFFO0lBQzNGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx1Q0FBK0IsQ0FBQyxJQUFJLENBQUE7QUFDM0QsQ0FBQyxDQUFBO0FBRlksUUFBQSx1QkFBdUIsMkJBRW5DIn0=